/* eslint-disable no-useless-concat */
/* eslint-disable max-len */
import axios from 'axios';
// import { URL_SERVER_BACKEND } from 'Config/routes';
// import { normalize, schema } from 'normalizr';

export const CALL_ACTIONS = 'CALL_API';

const CALL_API = (ENDPOINT, METHOD, DATA, PARAMS) => {
  const token = localStorage.getItem('token');
  return axios({
    method: METHOD,
    url: ENDPOINT,
    data: DATA || {},
    params: PARAMS || {},
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  // .then((res) => res)
  // .catch((rej) => Promise.reject(rej.response));
};

export default () => (next) => (actions) => {
  const callApi = actions[CALL_ACTIONS];
  if (typeof (callApi) === 'undefined') {
    return (next(actions));
  }

  const {
    METHOD,
    TYPES,
    DATA,
    PARAMS,
    ENDPOINT,
  } = callApi;

  if (typeof (ENDPOINT) !== 'string') throw new Error('Especific a string endpoint url');
  if (!Array.isArray(TYPES) || TYPES.length !== 3) throw new Error('Espected an array of 3 action types');
  if (!TYPES.every((type) => typeof (type) === 'string')) throw new Error('Espected action type to be a string');

  const actionWith = (data) => {
    const finalAction = { ...actions, ...data };
    delete (finalAction[CALL_ACTIONS]);
    return finalAction;
  };
  const [requestType, successType, errorType] = TYPES;
  next(actionWith({ type: requestType, isFetching: true }));

  return new Promise((resolve, reject) => {
    CALL_API(ENDPOINT, METHOD, DATA, PARAMS)
      .then((response) => {
        // console.log('############# CALL API then', response);
        next(actionWith({
          isFetching: false,
          type: successType,
          response,
        }));
        resolve(response.data, response);
      })
      .catch((response) => {
        // console.log('############# CALL API catch', errorType, response);
        next(actionWith({
          type: errorType,
          isFetching: false,
          response: response.response,
        }));
        reject(response.response?.data, response.response);
      });
  });
};
